import { PropertyWithSearchesForContin, SearchForContin } from './types';
import TextArea from '../../OrderEntry/ui/TextArea';
import { OrderContinFormPropertyWithSearches } from './OrderContinFormPropertyWithSearches';
import { FlexColumnDiv, FlexColumnRightDiv, FlexDiv, FlexSpan, Input, InputLabel } from './styled';
import { Label } from 'semantic-ui-react';

interface PropTypes {
  properties: PropertyWithSearchesForContin[];
  selectedSearches: SearchForContin[];
  emailAddresses: string[];
  defaultEmailAddresses: string[];
  dueBy: string;
  note: string;
  changeSearchSelection: (search: SearchForContin, checked: boolean) => void;
  changeSearchSelectionBulk: (searches: SearchForContin[], checked: boolean) => void;
  changeEmailAddress: (value: string, index: number) => void;
  changeDueBy: (value: string) => void;
  changeNote: (value: string) => void;
}

export const OrderContinForm = (props: PropTypes) => {
  return (
    <FlexDiv>
      <FlexColumnDiv>
        <InputLabel>Select Properties/Searches:</InputLabel>
        {props.properties.map(p => {
          return (
            <OrderContinFormPropertyWithSearches
              key={p.propertyId}
              p={p}
              selectedSearches={props.selectedSearches}
              changeSearchSelection={props.changeSearchSelection}
              changeSearchSelectionBulk={props.changeSearchSelectionBulk}
            />
          );
        })}
      </FlexColumnDiv>
      <FlexColumnRightDiv>
        <InputLabel>{`${
          props.defaultEmailAddresses.length > 0
            ? 'Default Account Recipients:'
            : 'Add Additional Recipients:'
        }`}</InputLabel>
        {props.defaultEmailAddresses.length > 0 && (
          <>
            <FlexSpan
              style={{ marginTop: 12, marginBottom: 8, cursor: 'default', flexWrap: 'wrap', maxWidth: 450 }}
            >
              {props.defaultEmailAddresses.map((a, index) => {
                return (
                  <span key={index} style={{ marginBottom: 10, marginRight: 4 }}>
                    <Label size="large" circular>
                      {a}
                    </Label>
                  </span>
                );
              })}
            </FlexSpan>
            <span style={{ maxWidth: 300 }}>
              <i>Add additional recipients:</i>
            </span>
          </>
        )}
        {props.emailAddresses.map((a, index) => {
          return (
            <Input
              key={index}
              onChange={(e: any) => {
                props.changeEmailAddress(e.target.value, index);
              }}
              value={a}
              placeholder={`Additional email address ${index + 1} (optional)`}
            />
          );
        })}
        <InputLabel style={{ marginTop: 26 }}>Due By:</InputLabel>
        <Input value={props.dueBy} type="date" onChange={e => props.changeDueBy(e.target.value)} />
        <TextArea
          error=""
          label="Notes:"
          value={props.note}
          placeholder={'Enter your notes here'}
          onChange={(e: any) => {
            props.changeNote(e.target.value);
          }}
          styles={{ width: 400, ' :focus': { outline: 'none' }, caretColor: '#8e8e93' }}
          divStyles={{ marginTop: 26, span: { fontSize: 18 } }}
        />
      </FlexColumnRightDiv>
    </FlexDiv>
  );
};
